import React, { FC } from "react";

type IProps = {
  width?: string;
  height?: string;
  color?: string;
};

const Close: FC<IProps> = ({ width = "w-6", height = "h-6", color }) => {
  return (
    <svg
      className={`${width} ${height} text-gray-600`}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  );
};

export default Close;
